module.exports = __webpack_public_path__ + "img/Character_Yelan_Thumb.afafa6e1.png";